// Route: /tools/visuals — LEGACY redirect → /tools/visual-explainer.
//
// Фронт Visual Explainer приведён к канону модуля: серверный модуль, контракт и
// tRPC-неймспейс уже назывались `visual-explainer`, расходился только адрес SPA.
// Старый путь обязан жить: он уехал в `action_url` уведомлений (Inngest
// `generateVisualAnalysis` кладёт `/tools/visuals/{id}`), в письма и в закладки
// пользователей. Схлопывать такие ссылки в Not Found нельзя.
//
// Валидируем легаси-ключи, чтобы битый URL не падал ДО редиректа. Дальше —
// `search as never`: контракт search принадлежит /tools/visual-explainer, её
// `validateSearch` (zod object) отбросит незнакомые ключи сама.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	category: z
		.enum(["problem", "graph", "formula", "handwriting", "diagram", "photo", "other"])
		.optional(),
	status: z.enum(["queued", "analyzing", "ready", "failed"]).optional(),
	q: z.string().optional(),
	demo: z.enum(["default", "loading", "empty", "error", "processing"]).optional(),
	create: z.boolean().optional(),
});

export const Route = createFileRoute("/tools/visuals/")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		// Схема цели идентична, но переклад явный: каст скрыл бы будущее
		// расхождение, если правку внесут только в одну сторону.
		throw redirect({
			to: "/tools/visual-explainer",
			search: {
				...(search.category ? { category: search.category } : {}),
				...(search.status ? { status: search.status } : {}),
				...(search.q ? { q: search.q } : {}),
				...(search.demo ? { demo: search.demo } : {}),
				...(search.create ? { create: search.create } : {}),
			},
			replace: true,
		});
	},
});
